import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// Build salt — bump to mint fresh asset hashes and abandon any edge-poisoned
// /assets/* URL (CF Pages SPA-fallback caches HTML under a hashed asset URL).
const __BUILD_SALT__ = "20260723a";
void __BUILD_SALT__;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
